import * as React from "react";
import PropTypes from "prop-types";

import styles from "./selling-statement.module.scss";

const SellingStatement = ({
  abcPantsAbTestFlag,
  currentVariant,
  desktopCopy,
  deviceType,
  mobileCopy
}) => {
  const shouldUseABCDescription =
    abcPantsAbTestFlag && !!currentVariant?.description;

  if (!mobileCopy && !shouldUseABCDescription) return null;

  const renderCopy = () => {
    if (shouldUseABCDescription) {
      return currentVariant?.description;
    }
    if (!deviceType.isMobile && !!desktopCopy) {
      return desktopCopy;
    }
    return mobileCopy;
  };

  return (
    /* Desktop & tablet devices render desktop copy if it exists */
    <div className={styles.sellingStatement}>{renderCopy()}</div>
  );
};

SellingStatement.propTypes = {
  desktopCopy: PropTypes.string,
  mobileCopy: PropTypes.string.isRequired
};

SellingStatement.defaultProps = {
  desktopCopy: ""
};

export default SellingStatement;
